import { useState, useEffect } from 'react';
import { AlgorithmSettingsProps } from 'src/components/auto-shapes/types';
import { AutoShapeAlgorithmType } from 'src/gql/graphql';

export function InternalWallFinishes3DSettings({
  value,
  onChange,
  onValidityChange,
}: AlgorithmSettingsProps<AutoShapeAlgorithmType.InternalWallFinishes_3D>) {
  // Example implementation
  const [localValue, setLocalValue] = useState(value);

  const validateInput = (input: any) => {
    return true;
  };

  useEffect(() => {
    // Validate and update parent
    const isValid = validateInput(localValue);
    onValidityChange(isValid);
    onChange(localValue);
  }, [localValue, onChange, onValidityChange]);

  return (
    // Your settings UI here
    <div>External Wall Finishes 3D Settings</div>
  );
}
